import React from 'react'
import PropTypes from 'prop-types'
import {Input} from 'reactstrap'
import Button from "reactstrap/es/Button"

class ListItemsFooter extends React.Component {
    parsePagination = () => {
        const {pagination} = this.props
        const {page, limit: limitProps, total: totalProps} = pagination
        const total = totalProps > 0 ? totalProps : 0
        const limit = limitProps > 0 ? limitProps : 0
        const totalPages = limit && Math.ceil(total / limit)

        return {page, total: totalPages, limit}
    }

    _handleChangeLimit = (e) => {
        const {value} = e.target
        const limit = parseInt(value)
        this.props.onChangePagination({limit})
    }

    _onChangePage = (name, value) => {

        const filter = Object.assign({}, this.props.filter)

        delete filter['beforeId']
        delete filter['afterId']

        filter[name] = value

        this.props.onChangeFilter(filter)
    }

    render() {
        const pagination = this.parsePagination()
        const {prev, next, loading, filter} = this.props

        return (
            <div className='ListItemsFooter'>
                <div className='DataTableFooter header-elements-inline py-3'>
                    <div className='d-flex align-items-center'>Show
                        <Input className='mx-2' type='select' value={pagination.limit}
                               onChange={this._handleChangeLimit}>
                            <option>10</option>
                            <option>50</option>
                            <option>100</option>
                            <option>200</option>
                            <option>500</option>
                            <option>1000</option>
                            <option>2000</option>
                            <option>5000</option>
                        </Input>
                        entries
                    </div>

                    <div className="CustomPagination">
                        <Button
                            disabled={(!filter.hasOwnProperty('beforeId') && !filter.hasOwnProperty('afterId')) || prev === null || loading}
                            className="mr-3"
                            color="link"
                            onClick={() => this._onChangePage('beforeId', prev)}
                        >
                            <i className="fa fa-long-arrow-left mr-1"/>Previous
                        </Button>
                        <Button
                            disabled={next === null || loading}
                            color="link"
                            onClick={() => this._onChangePage('afterId', next)}
                        >
                            Next<i className="fa fa-long-arrow-right ml-1"/>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

ListItemsFooter.propTypes = {
    filter: PropTypes.object.isRequired,
    next: PropTypes.string,
    prev: PropTypes.string,
    loading: PropTypes.bool,
    pagination: PropTypes.object.isRequired,
    onChangePagination: PropTypes.func.isRequired,
    onChangeFilter: PropTypes.func.isRequired
};

export default ListItemsFooter;